export default "__VITE_ASSET__BqGuaaOA__"